import React, { useContext } from "react";
import { CatTagContext } from "../contexts/CatTagContext";
import { MemoContext } from "../contexts/MemoContext";
import { Popconfirm } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { useHistory } from "react-router-dom";

const DeleteIcon = ({ mid }) => {
  const history = useHistory();
  const { fetchMemo } = useContext(MemoContext);
  const { fetchCatTag } = useContext(CatTagContext);
  const handleDel = () => {
    axios
      .delete(`/memo/${mid}`)
      .then(() => {
        fetchCatTag();
        fetchMemo();
        history.push("/");
      })
      .catch((e) => {
        console.log(e);
      });
  };
  return (
    <div>
      <Popconfirm
        title="You want to delete this memo ?"
        icon={<QuestionCircleOutlined style={{ color: "red" }} />}
        onConfirm={handleDel}
        okType="danger"
        okText="Yes"
        cancelText="Cancel"
      >
        <svg
          className="w-6 h-6 text-red-400 cursor-pointer hover:text-red-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          />
        </svg>
      </Popconfirm>
    </div>
  );
};

export default DeleteIcon;
